import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import { forfeitschema, walkoverListSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/forfeits/actions';
import { ForfeitsActionTypes as types } from 'app/ducks/forfeits/types';

function* createForfeitSaga(action): any {
  yield put(sagaActions.createForfeitPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).forfeits.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, forfeitschema);

    yield put(sagaActions.createForfeitSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createForfeitFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updateForfeitSaga(action): any {
  yield put(sagaActions.updateForfeitPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).forfeits.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, forfeitschema);

    yield put(sagaActions.updateForfeitSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateForfeitFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* getForfeitSaga(action): any {
  yield put(sagaActions.getForfeitPending());
  const [error, response] = yield (yield TeammoApi(yield select())).forfeits.show(
    action.payload,
  );
  if (response) {
    const normalizedResponse = normalize(response, forfeitschema);
    yield put(sagaActions.getForfeitSuccess(normalizedResponse));
    return normalizedResponse.entities.teams[normalizedResponse.result];
  }
  yield put(
    handleError(error, sagaActions.getForfeitFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
  );
  return null;
}

function* getAllForfeitsSaga(action): any {
  yield put(
    sagaActions.getAllForfeitsPending(action.payload.compile ? action.payload.pagination : {}),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(yield select((state) => state.forfeits.pagination))
    : action.payload.pagination;

  const [error, response] = yield (yield TeammoApi(yield select())).forfeits.list(
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(response, walkoverListSchema);

    yield put(
      sagaActions.getAllForfeitsSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllForfeitsFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createForfeitSagaWatcher(): any {
  yield takeLatest(types.CREATE_FORFEIT_REQUESTED, createForfeitSaga);
}

function* updateForfeitSagaWatcher(): any {
  yield takeLatest(types.UPDATE_FORFEIT_REQUESTED, updateForfeitSaga);
}

function* getForfeitSagaWatcher(): any {
  yield takeEvery(types.GET_FORFEIT_REQUESTED, getForfeitSaga);
}

function* getAllForfeitsSagaWatcher(): any {
  yield takeEvery(types.GET_ALL_FORFEITS_REQUESTED, getAllForfeitsSaga);
}

export default function* root(): any {
  yield all([
    createForfeitSagaWatcher(),
    updateForfeitSagaWatcher(),
    getForfeitSagaWatcher(),
    getAllForfeitsSagaWatcher(),
  ]);
}
